import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Divider } from '@material-ui/core';

import CloseButton from 'components/CustomButtons/CloseButton';
import {
  getOriginalPayments,
  getPaymentsTotal,
  getIsSpecialPaymentMenuSelected,
} from 'reducers/Payments';
import { getCheckBehavior } from 'reducers/configs/settings';

import { PaymentList, PaymentActions, GiftCard } from '../../components';
import PayCheck from '../../components/PayCheck';
import OriginalPaymentList from '../../components/OriginalPaymentList';
import CustomPaymentType from '../../components/CustomPaymentType';

const PaymentMobile: React.FC<{ voidHandler: () => void }> = ({
  voidHandler,
}) => {
  const { t } = useTranslation('payment');
  const isReturn = useSelector(getPaymentsTotal) < 0;
  const hasOriginalPayments = 0 < useSelector(getOriginalPayments).length;
  const isReferencedReturn = isReturn && hasOriginalPayments;

  const checkBehaviour = useSelector(getCheckBehavior);
  const {
    isGiftCardMenuSelected,
    isCheckMenuSelected,
    isCustomPaymentTypeMenuSelected,
  } = useSelector(getIsSpecialPaymentMenuSelected);

  const shouldShowCheck = checkBehaviour === 'OLD' && isCheckMenuSelected;

  const getView = useCallback(() => {
    if (isGiftCardMenuSelected) {
      return <GiftCard />;
    }
    if (shouldShowCheck) {
      return <PayCheck />;
    }
    if (isCustomPaymentTypeMenuSelected) {
      return <CustomPaymentType />;
    }

    return (
      <>
        <PaymentList />
        {isReferencedReturn ? (
          <>
            <OriginalPaymentList />
            <Divider style={{ marginBottom: '1em' }} />
          </>
        ) : null}
        <PaymentActions voidHandler={voidHandler} />
      </>
    );
  }, [
    isCustomPaymentTypeMenuSelected,
    isGiftCardMenuSelected,
    isReferencedReturn,
    shouldShowCheck,
    voidHandler,
  ]);

  return (
    <Box padding="1.5rem">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{t('buttons.title')}</Typography>
        <CloseButton action={voidHandler} />
      </Box>
      <Divider style={{ margin: '0.5rem 0' }} />
      {getView()}
    </Box>
  );
};

export default PaymentMobile;
